import {
  MockHook,
  useSnackbarNotification,
} from '@jupiterone/jupiter-web-toolkit';
import { ChangeEvent, FormEvent, useState } from 'react';
import { useReportIssue } from '@jupiterone/jupiter-web-toolkit/src/hooks/useReportIssue';
import { validateReportIssueFormFields } from './validateReportIssueFormFields';

export enum Severity {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}
export interface ReportIssueFormValues {
  title: string;
  stepsToReproduce: string;
  expectedBehavior: string;
  severity: Severity;
}

export interface ReportIssueFormProps {
  onReportComplete?: VoidFunction;
}
const useReportIssueFormLogic = (props: ReportIssueFormProps) => {
  const { reportIssue, loading } = useReportIssue();
  const notifications = useSnackbarNotification();
  const [errors, setErrors] = useState<
    ReturnType<typeof validateReportIssueFormFields>
  >({});
  const [values, setValues] = useState<ReportIssueFormValues>({
    title: '',
    stepsToReproduce: '',
    expectedBehavior: '',
    severity: Severity.MEDIUM,
  });
  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrors(null);
    const errors = validateReportIssueFormFields(values);
    if (errors) {
      setErrors(errors);
    } else {
      await reportIssue(values);
      props.onReportComplete?.();
      notifications.success('Thank you for submitting a bug report.', 2000);
    }
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) =>
    setValues({
      ...values,
      [e.target.name as keyof typeof values]: e.target.value,
    });

  return { loading, errors, handleChange, handleSubmit };
};

export type ReportIssueFormComponentProps = ReturnType<
  typeof useReportIssueFormLogic
>;
export const MOCK_REPORT_ISSUE_FORM_PROPS: ReportIssueFormComponentProps = {
  loading: false,
  errors: { test: true } as any,
  handleSubmit: MockHook.mockFunction,
  handleChange: MockHook.mockFunction,
};
export default MockHook.useMockHook(
  useReportIssueFormLogic,
  MOCK_REPORT_ISSUE_FORM_PROPS
);
